import InputCheckbox from './InputCheckbox';
export default InputCheckbox;



// WEBPACK FOOTER //
// ./src/components/shared/InputCheckbox/index.js